import React from "react";
import PropTypes from "prop-types";

const GridViewIcon = ({
  width,
  size,
  height,
  style,
  color = "#D1D4D6",
  noPointer,
  title,
  ...props
}) => {
  return (
    <svg
      {...props}
      style={style}
      data-no-pointer={noPointer}
      width={width || size || 24}
      height={height || size || 24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="title"
    >
      {title && <title>{title}</title>}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <rect
          stroke={color}
          strokeWidth="2"
          x="6"
          y="6"
          width="4.25"
          height="4.25"
          rx="1"
        />
        <rect
          stroke={color}
          strokeWidth="2"
          x="6"
          y="13.75"
          width="4.25"
          height="4.25"
          rx="1"
        />
        <rect
          stroke={color}
          strokeWidth="2"
          x="13.75"
          y="6"
          width="4.25"
          height="4.25"
          rx="1"
        />
        <rect
          stroke={color}
          strokeWidth="2"
          x="13.75"
          y="13.75"
          width="4.25"
          height="4.25"
          rx="1"
        />
      </g>
    </svg>
  );
};

GridViewIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
  color: PropTypes.string,
  noPointer: PropTypes.bool,
  title: PropTypes.string
};

export default GridViewIcon;
